import React, { useEffect } from 'react';

import { useApplicationState, updateApplicationTitle } from '../../utilities/applicationState';
import ApiUsageView from '../shared/apiUsage/apiUsageView';
import './apiUsageView.scss';

export default function UsageTab() {
	const [, dispatch] = useApplicationState();

	useEffect(() => {
		dispatch(updateApplicationTitle('API USAGE'));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="mx-24 my-10">
			<div slot="breadcrumb" className="mb-5" onClick={() => { }}>
				API usage <span>/</span>
			</div>
			<span slot="title" className="text-heading-07 font-black">Billable API Transaction History</span>
			<ApiUsageView isAdminView={false} />
		</div>
	);
}
